<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 pt-4 pb-2 px-4 v-if="err">
        <v-alert :value="true" type="error"> {{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pt-4 pb-2 px-4 v-if="success">
        <v-alert type="success" :value="true">{{success}}</v-alert>
      </v-flex>
      <v-card-title class="py- px-4 layout row wrap">
        <v-btn class="primary ma-0" @click='$router.push({ name: "licenseCreate" })'>{{$lang.actions.createLicense}}</v-btn>
        <v-checkbox
          color="primary"
          class="ml-3 mt-0"
          :label="$lang.labels.showActive"
          v-model="showActive"
          hide-details
        />
        <v-spacer/>
        <v-text-field
          class="min-w max-w"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="showActive ? activeLicenses : allLicenses"
        :search="search"
        :loading="allLicenses.length === 0"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td class="min-w-lg">{{ props.item.companyName }}</td>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.licenseType }}</td>
          <td>{{ props.item.moonInstanceName }}</td>
          <td>{{ formatDate(props.item.getsActiveOn) }}</td>
          <td>{{ formatDate(props.item.expiresOn) }}</td>
          <td>{{ props.item.status }}</td>
          <td class="min-w-lg">
            <v-btn 
              class="primary mx-0 elevation-1" 
              @click="viewLicense(props.item)">
              {{$lang.actions.view}}
            </v-btn>
            <v-btn 
              class="primary elevation-1"
              @click="changeStatus(props.item)">
              {{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" type="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="confirmationModal" v-model="confirmationModal" max-width="500">
      <confirmation-modal :data="confirmationData" @close="confirmationModal = false" @change="deactivate($event)"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    components: {
      confirmationModal: () => import('../modals/DeactivationModal'),
    },
    data() {
      return {
        err: '',
        success: '',
        search: '',
        headers: [
          { text: this.$lang.labels.company, value: 'companyName', align: 'left' },
          { text: this.$lang.labels.licenseID, value: 'id', align: 'left' },
          { text: this.$lang.header.licenseType, value: 'licenseType', align: 'left' },
          { text: this.$lang.header.moonInstName, value: 'moonInstanceName', align: 'left' },
          { text: this.$lang.header.activationDate, value: 'getsActiveOn', align: 'left' },
          { text: this.$lang.header.expiryDate, value: 'expiresOn', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allLicenses: [],
        confirmationModal: false,
        confirmationData: {
          id: null,
          url: 'license',
        },
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      viewLicense(license) {
        this.$router.push({ name: 'license', params: {id: license.id}});
      },
      changeStatus(license) {
        if (license.status === 'inactive' || license.status === 'draft') {
          this.$http.post(`license/activate/${license.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.$set(license, 'status', 'active');
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
        } else if (license.status === "active") {
          this.confirmationData.id = license.id;
          this.confirmationModal = true;
        }
      },
      deactivate(id) {
        const result = this.allLicenses.find( data => data.id === id );
        this.$set(result, 'status', 'inactive');
      },
    },
    computed: {
      activeLicenses() {
        const licenses = this.allLicenses;
        const activeLicenses = [];
        for (let i=0; licenses.length > i; i++) {
          if (licenses[i].status === 'active' || licenses[i].status === 'draft') {
            activeLicenses.push(licenses[i]);
          }
        }
        return activeLicenses;
      },
    },
    created() {
      this.$http.get('license')
        .then((res) => {
          if(res.body.status === 'Success') {
            this.allLicenses = res.body.licenses;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        })
    },
  };
</script>



// WEBPACK FOOTER //
// Licenses.vue?27998b52